webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(155)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  "data-v-b85489d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(154)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  "data-v-aaa1c104",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(189),
  /* scopeId */
  "data-v-11aaa95a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(151)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  "data-v-64ceb16f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(152)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  "data-v-76ac51e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(188),
  /* scopeId */
  "data-v-0d892fe2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  "data-v-5c738e9d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(149)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  "data-v-5e3bee70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(190),
  /* scopeId */
  "data-v-121070d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  "data-v-3ce9872a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  "data-v-564f38d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(187),
  /* scopeId */
  "data-v-0cd43b34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_PagesView__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_PagesView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_PagesView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_HomeView__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_HomeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_HomeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_MovieView__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_MovieView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_MovieView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_BookView__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_BookView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_BookView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_StatusView__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_StatusView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_StatusView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_GroupView__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_GroupView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_GroupView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_SubjectView__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_SubjectView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_SubjectView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_DetailView__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_DetailView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_DetailView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_SearchView__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_SearchView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_SearchView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_LoginView__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_LoginView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_LoginView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_RegisterView__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_RegisterView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_RegisterView__);















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/pages/'
  }, {
    path: '/pages',
    component: __WEBPACK_IMPORTED_MODULE_2__views_PagesView___default.a,
    children: [{
      path: '',
      redirect: '/pages/home'
    }, {
      path: 'home',
      name: 'HomeView',
      component: __WEBPACK_IMPORTED_MODULE_3__views_HomeView___default.a
    }, {
      path: 'movie',
      name: 'MovieView',
      component: __WEBPACK_IMPORTED_MODULE_4__views_MovieView___default.a
    }, {
      path: 'book',
      name: 'BookView',
      component: __WEBPACK_IMPORTED_MODULE_5__views_BookView___default.a
    }, {
      path: 'status',
      name: 'StatusView',
      component: __WEBPACK_IMPORTED_MODULE_6__views_StatusView___default.a
    }, {
      path: 'group',
      name: 'GroupView',
      component: __WEBPACK_IMPORTED_MODULE_7__views_GroupView___default.a
    }, {
      path: 'detail/:id',
      name: 'DetailView',
      component: __WEBPACK_IMPORTED_MODULE_9__views_DetailView___default.a
    }]
  }, {
    path: '/pages/:classify/subject/:id',
    name: 'SubjectView',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_2__views_PagesView___default.a,
      subject: __WEBPACK_IMPORTED_MODULE_8__views_SubjectView___default.a
    }
  }, {
    path: '/search',
    name: 'SearchView',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_2__views_PagesView___default.a,
      search: __WEBPACK_IMPORTED_MODULE_10__views_SearchView___default.a
    }
  }, {
    path: '/login',
    name: 'LoginView',
    component: __WEBPACK_IMPORTED_MODULE_11__views_LoginView___default.a
  }, {
    path: '/register',
    name: 'RegisterView',
    component: __WEBPACK_IMPORTED_MODULE_12__views_RegisterView___default.a
  }, {
    path: '*',
    redirect: '/pages/'
  }]
}));

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_movie__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_activities__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_book__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_subject__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_group__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_search__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_user__ = __webpack_require__(67);











__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    movie: __WEBPACK_IMPORTED_MODULE_2__modules_movie__["a" /* default */],
    activities: __WEBPACK_IMPORTED_MODULE_3__modules_activities__["a" /* default */],
    book: __WEBPACK_IMPORTED_MODULE_4__modules_book__["a" /* default */],
    subject: __WEBPACK_IMPORTED_MODULE_5__modules_subject__["a" /* default */],
    group: __WEBPACK_IMPORTED_MODULE_6__modules_group__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_7__modules_search__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_8__modules_user__["a" /* default */]
  }
}));

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(158)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_normalize_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_normalize_css__);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_scroll_behavior___default.a, { router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */] });

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent_jsonp__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_superagent_jsonp__);




var state = {
  events: [],
  temp: [],
  skip: 0,
  eventItem: {}
};

var mutations = {
  loadMore: function loadMore(state, payload) {
    state.skip += 3;
    state.events = state.events.concat(payload.res);
  },
  getSingleEvent: function getSingleEvent(state, payload) {
    state.eventItem = payload.res;
  }
};

var actions = {
  loadMore: function loadMore(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get('https://api.douban.com/v2/event/list?loc=108288&start=' + state.skip + '&count=3').use(__WEBPACK_IMPORTED_MODULE_2_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'loadMore',
          res: res.body.events
        });
      }
    });
  },
  getSingleEvent: function getSingleEvent(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get('https://api.douban.com/v2/event/' + payload.id).use(__WEBPACK_IMPORTED_MODULE_2_superagent_jsonp___default.a).end(function (err, res) {
        if (!err) {
          commit({
            type: 'getSingleEvent',
            res: res.body
          });
          resolve(res);
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_jsonp__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp__);



var state = {
  novel: [],
  reality: [],
  travel: [],
  bookTags: [{
    title: '不可饶恕的女人们',
    href: 'https://m.douban.com/doulist/35573',
    color: '#42BD56'
  }, {
    title: '爱欲书',
    href: 'https://m.douban.com/doulist/38088147',
    color: '#FF4055'
  }, {
    title: '他们还写侦探小说',
    href: 'https://m.douban.com/doulist/645579',
    color: '#4F9DED'
  }, {
    line: true
  }, {
    title: '人生识字始忧患',
    href: 'https://m.douban.com/doulist/192653',
    color: '#CC3344'
  }, {
    title: '詩歌書店',
    href: 'https://m.douban.com/doulist/89925',
    color: '#FFAC2D'
  }, {
    title: '尝试理解人类变化无常不可测心理相关小荐',
    href: 'https://m.douban.com/doulist/45361809',
    color: '#3BA94D'
  }]
};

var mutations = {
  getBook: function getBook(state, payload) {
    switch (payload.tag) {
      case 'novel':
        state.novel = payload.res;
        break;
      case 'reality':
        state.reality = payload.res;
        break;
      case 'travel':
        state.travel = payload.res;
        break;
      default:
        state.novel = payload.res;
    }
  }
};

var actions = {
  getBook: function getBook(_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/book/search?q=虚构类&count=8').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'getBook',
          tag: 'novel',
          res: res.body.books
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/book/search?q=非虚构类&count=8').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'getBook',
          tag: 'reality',
          res: res.body.books
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/book/search?q=旅行&count=8').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'getBook',
          tag: 'travel',
          res: res.body.books
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  group_a: [],
  group_b: [],
  group_c: []
};

var mutations = {
  getGroup: function getGroup(state, payload) {
    switch (payload.tag) {
      case 'a':
        state.group_a = payload.res;
        break;
      case 'b':
        state.group_b = payload.res;
        break;
      case 'c':
        state.group_c = payload.res;
        break;
      default:
        console.log('[Error]:Api is error!');
    }
  }
};

var actions = {
  getGroup: function getGroup(_ref, payload) {
    var commit = _ref.commit;

    var dataA = [{
      title: '成都租房',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img3.doubanio.com/icon/g117205-2.jpg'
      },
      group_member: '43736',
      group_topic: {
        title: '天府四街临江苑套一出租个人 无中介费噢',
        time: '3分钟前更新：'
      }
    }, {
      title: '北京租房（非中介）',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img3.doubanio.com/icon/g279962-3.jpg'
      },
      group_member: '53736',
      group_topic: {
        title: '9号线丰台南路站看丹桥新华街四里，次卧出租，押一付一',
        time: '刚刚更新：'
      }
    }, {
      title: '深圳福田租房（个人房源免费推广）',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img3.doubanio.com/icon/g117205-2.jpg'
      },
      group_member: '4373',
      group_topic: {
        title: '福田福民岗厦复式单间整租，2800，可短租',
        time: '刚刚更新：'
      }
    }];
    var dataB = [{
      title: '想不想很多人帮你！',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img1.doubanio.com/icon/g14859-17.jpg'
      },
      group_member: '431999',
      group_topic: {
        title: '想转专业去学日语大家有神马建议？',
        time: '4分钟前更新：'
      }
    }, {
      title: '我们都有秘密',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img5.doubanio.com/icon/g399184-6.jpg'
      },
      group_member: '96960',
      group_topic: {
        title: '北京 征个女生',
        time: '1分钟前更新：'
      }
    }, {
      title: '文艺青年装逼会',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img1.doubanio.com/icon/g17947-8.jpg'
      },
      group_member: '43736',
      group_topic: {
        title: '文艺青年装逼会',
        time: '3分钟前更新：'
      }
    }];
    var dataC = [{
      title: '我爱代购&amp;海淘☺微信号',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img5.doubanio.com/icon/g37539-6.jpg'
      },
      group_member: '431999',
      group_topic: {
        title: '靠谱小日代 薇信直播定位+邮寄单号 可拼邮可直邮 保证品 ～笔芯',
        time: '4分钟前更新：'
      }
    }, {
      title: 'PiaPia团✿团购',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img3.doubanio.com/icon/g573696-2.jpg'
      },
      group_member: '96960',
      group_topic: {
        title: '【想买】之前团过的包要吗？',
        time: '1小时前更新：'
      }
    }, {
      title: '我们一起海淘',
      subtype: 'group',
      id: 1234,
      images: {
        small: 'https://img3.doubanio.com/icon/g25704-22.jpg'
      },
      group_member: '743736',
      group_topic: {
        title: '靠谱小日代 薇信直播定位+邮寄单号 可拼邮可直邮 保正品～笔芯',
        time: '3分钟前更新：'
      }
    }];

    setTimeout(function () {
      commit({
        type: 'getGroup',
        tag: 'a',
        res: dataA
      });
    }, 1000);
    setTimeout(function () {
      commit({
        type: 'getGroup',
        tag: 'b',
        res: dataB
      });
    }, 3000);
    setTimeout(function () {
      commit({
        type: 'getGroup',
        tag: 'c',
        res: dataC
      });
    }, 200);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_jsonp__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp__);



var state = {
  hotMovies: [],
  newMovies: [],
  topMovies: [],
  movieTags: [{
    title: '同时入选IMDB250和豆瓣电影250的电影',
    href: 'https://m.douban.com/doulist/968362/',
    color: '#FFAC2D'
  }, {
    title: '带你进入不正常的世界',
    href: 'https://m.douban.com/doulist/16002',
    color: '#FF4055'
  }, {
    title: '用电【影】来祭奠逝去的岁月',
    href: 'https://m.douban.com/doulist/190343',
    color: '#4F9DED'
  }, {
    title: '女孩们的故事【电影】',
    href: 'https://m.douban.com/doulist/1125971',
    color: '#FFC46C'
  }, {
    line: true
  }, {
    title: '科幻是未来的钥匙——科幻启示录【科幻题材】',
    href: 'https://m.douban.com/doulist/4253902',
    color: '#2384E8'
  }, {
    title: '美国生活面面观',
    href: 'https://m.douban.com/doulist/121326',
    color: '#3BA94D'
  }, {
    title: '2015终极期待',
    href: 'https://m.douban.com/doulist/37479562',
    color: '#42BD56'
  }, {
    title: '经典韩国电影——收集100部',
    href: 'https://m.douban.com/doulist/458087',
    color: '#CC3344'
  }]
};

var mutations = {
  getMovie: function getMovie(state, payload) {
    switch (payload.tag) {
      case 'hotMovies':
        state.hotMovies = payload.res;
        break;
      case 'newMovies':
        state.newMovies = payload.res;
        break;
      case 'topMovies':
        state.topMovies = payload.res;
        break;
      default:
        state.hotMovies = payload.res;
    }
  }
};

var actions = {
  getMovie: function getMovie(_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/movie/in_theaters?count=8').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'getMovie',
          tag: 'hotMovies',
          res: res.body.subjects
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/movie/coming_soon?count=8').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'getMovie',
          tag: 'newMovies',
          res: res.body.subjects
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/movie/top250?count=8').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'getMovie',
          tag: 'topMovies',
          res: res.body.subjects
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_jsonp__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp__);



var state = {
  queryRes_movie: [],
  queryRes_book: [],
  queryRes_music: []
};

var mutations = {
  query: function query(state, payload) {
    switch (payload.tag) {
      case 'movie':
        state.queryRes_movie = payload.res;
        break;
      case 'book':
        state.queryRes_book = payload.res;
        break;
      case 'music':
        state.queryRes_music = payload.res;
        break;
      default:
        console.log('[Error]:Api is error!');
    }
  }
};

var actions = {
  query: function query(_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('https://api.douban.com/v2/movie/search?q=' + payload.queryStr + '&count=3').use(__WEBPACK_IMPORTED_MODULE_1_superagent_jsonp___default.a).end(function (err, res) {
      if (!err) {
        commit({
          type: 'query',
          tag: 'movie',
          res: res.body.subjects
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent_jsonp__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_superagent_jsonp__);




var state = {
  subject: {},
  classify: '',
  adImgUrl: 'http://img.hb.aicdn.com/c1dd2a72fa6412bd455868be68ca402cf9f94b84e688-WMTPtp_fw658',
  questions: [{
    title: '大家为什么对国产片这么苛刻？',
    comments: '35回答'
  }, {
    title: '有没有人喜欢凯凯王版的汤川学？',
    comments: '19回答'
  }, {
    title: '真的有饭店的打包袋长的和优衣库一样吗？',
    comments: '11回答'
  }, {
    title: '最后结尾 石鸿问“这道题难吗？”，唐川说“很难”，什么意思？  ?',
    comments: '7回答'
  }]
};

var getters = {
  subjectMeta: function subjectMeta(state) {
    if (state.classify === 'movie') {
      return state.subject.year + '/' + state.subject.genres.join(' / ') + ' / ' + state.subject.casts.map(function (item) {
        return item.name;
      }).join(' / ') + ' / ' + state.subject.directors.map(function (item) {
        return item.name;
      }).join(' / ') + ' / ' + state.subject.countries.join(' / ');
    } else if (state.classify === 'book') {
      return state.subject.author.join(' / ') + state.subject.translator.join(' / ') + ' / ' + state.subject.publisher + ' / ' + state.subject.binding + ' / ' + state.subject.pages + ' / ' + state.subject.price + ' / ' + state.subject.pubdate;
    }
  },

  summary: function summary(state) {
    if (state.subject.summary) {
      return state.subject.summary.slice(0, 120);
    }
  },

  genres: function genres(state) {
    if (state.classify === 'book') {
      return state.subject.tags;
    } else if (state.classify === 'movie') {
      return state.subject.genres;
    }
  }
};

var mutations = {
  getSingleSubject: function getSingleSubject(state, payload) {
    state.classify = payload.classify;
    state.subject = payload.res;
  }
};

var actions = {
  getSingleSubject: function getSingleSubject(_ref, payload) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      switch (payload.classify) {
        case 'movie':
          __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get('https://api.douban.com/v2/' + payload.classify + '/subject/' + payload.id).use(__WEBPACK_IMPORTED_MODULE_2_superagent_jsonp___default.a).end(function (err, res) {
            if (!err) {
              commit({
                type: 'getSingleSubject',
                classify: payload.classify,
                res: res.body
              });
              resolve(res);
            }
          });
          break;
        case 'book':
          __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get('https://api.douban.com/v2/' + payload.classify + '/' + payload.id).use(__WEBPACK_IMPORTED_MODULE_2_superagent_jsonp___default.a).end(function (err, res) {
            if (!err) {
              commit({
                type: 'getSingleSubject',
                classify: payload.classify,
                res: res.body
              });
              resolve(res);
            }
          });
          break;
        default:
          console.log('[Error]:Api is error!');
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);



var state = {
  login_email: '',
  login_token: '',
  login_name: '',
  temp_email: '',
  temp_token: '',
  temp_name: ''
};

var getters = {
  currentUser: function currentUser(state) {
    return {
      email: state.login_email,
      token: state.login_token,
      name: state.login_name
    };
  }
};

var mutations = {
  updateData: function updateData(state, payload) {
    switch (payload.name) {
      case 'email':
        state.temp_email = payload.value;
        break;
      case 'token':
        state.temp_token = payload.value;
        break;
      case 'name':
        state.temp_name = payload.name;
        break;
      default:
        console.log('Error:Dont directly mutate Vuex store');
    }
  },
  getLocalUser: function getLocalUser(state) {
    state.login_email = localStorage.getItem('email');
    state.login_token = localStorage.getItem('token');
    state.login_name = localStorage.getItem('name');
  },
  setUser: function setUser(state, payload) {
    state.login_email = payload.email;
    state.login_token = payload.token;
    state.login_name = payload.name;
  },
  logout: function logout(state) {
    localStorage.removeItem('email');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    state.login_email = '';
    state.login_token = '';
    state.login_name = '';
  }
};

var actions = {
  login: function login(_ref, payload) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get('https://douban.herokuapp.com/user/' + payload.email).set('Authorization', 'Bearer ' + payload.token).then(function (res) {
        commit({
          type: 'setUser',
          email: res.body.email,
          token: res.body.token,
          name: res.body.name
        });
        resolve(res);
      }, function (err) {
        reject(err);
      });
    });
  },
  register: function register(_ref2, payload) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post('https://douban.herokuapp.com/user/').send({
        email: payload.email,
        pass: payload.pass,
        name: payload.name
      }).then(function (res) {
        localStorage.setItem('token', res.body.token);
        localStorage.setItem('email', res.body.email);
        localStorage.setItem('name', res.body.name);

        commit({
          type: 'setUser',
          email: res.body.email,
          token: res.body.token,
          name: res.body.name
        });
        resolve(res);
      }, function (err) {
        reject(err);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'banner',
  props: {
    title: {
      type: String,
      required: false,
      default: '打开App, 浏览更多'
    },

    adImg: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card',
  props: {
    mold: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'download-app',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Rating__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Rating__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  components: { Rating: __WEBPACK_IMPORTED_MODULE_0__components_Rating___default.a },
  props: {
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-bar',
  data: function data() {
    return {};
  },

  methods: {
    showTalion: function showTalion() {
      this.$emit('showTalion');
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list',
  props: {
    mold: {
      type: String,
      default: 'basic'
    },
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  },

  filters: {
    subStr: function subStr(value) {
      var newVal = value.replace(/<.*?>/g, '');
      return newVal.slice(0, 30);
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'marking',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rating',
  props: {
    rating: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      full: 0,
      half: 0,
      gray: 0
    };
  },
  created: function created() {
    var average = this.rating.average;
    this.full = parseInt(average / 2);
    this.half = average % 2 === 0 ? 0 : 1;
    this.gray = 5 - this.full - this.half;
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Rating__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'scroller',
  props: ['title', 'type', 'items'],
  components: { Rating: __WEBPACK_IMPORTED_MODULE_0__Rating___default.a },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-nav',
  props: {
    mold: {
      type: String,
      default: 'quickNav'
    }
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentLink: function currentLink() {
      return this.currentUser.name ? 'StatusView' : 'LoginView';
    },
    holder: function holder() {
      return this.currentUser.name ? this.currentUser.name : '请先登录';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['currentUser'])),
  methods: {
    logout: function logout() {
      this.$store.commit({
        type: 'logout'
      });
      this.$router.push({ name: 'HomeView' });
    }
  },
  created: function created() {
    if (localStorage.getItem('email')) {
      this.$store.commit({
        type: 'getLocalUser'
      });
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tags',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'types',
  data: function data() {
    return {
      baseUri: 'https://m.douban.com/',
      items: [{
        title: '经典',
        href: 'movie/classic'
      }, {
        title: '冷门佳片',
        href: 'movie/underrated'
      }, {
        title: '豆瓣高分',
        href: 'movie/doubantop'
      }, {
        title: '动作',
        href: 'movie/action'
      }, {
        title: '喜剧',
        href: 'movie/comedy'
      }, {
        title: '爱情',
        href: 'movie/love'
      }, {
        title: '悬疑',
        href: 'movie/mystery'
      }, {
        title: '恐怖',
        href: 'movie/horror'
      }, {
        title: '科幻',
        href: 'movie/scifi'
      }, {
        title: '治愈',
        href: 'movie/sweet'
      }, {
        title: '文艺',
        href: 'movie/artfilm'
      }, {
        title: '成长',
        href: 'movie/youth'
      }, {
        title: '动画',
        href: 'movie/animation'
      }, {
        title: '华语',
        href: 'movie/chinese'
      }, {
        title: '欧美',
        href: 'movie/western'
      }, {
        title: '韩国',
        href: 'movie/korean'
      }, {
        title: '日本',
        href: 'movie/japanese'
      }]
    };
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-bar',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentLink: function currentLink() {
      return this.currentUser.name ? 'HomeView' : 'LoginView';
    },
    holder: function holder() {
      return this.currentUser.name ? this.currentUser.name : '请先登录';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['currentUser'])),
  created: function created() {
    if (localStorage.getItem('email')) {
      this.$store.commit({
        type: 'getLocalUser'
      });
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Scroller__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Types__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'book-view',
  components: { Scroller: __WEBPACK_IMPORTED_MODULE_2__components_Scroller___default.a, Types: __WEBPACK_IMPORTED_MODULE_3__components_Types___default.a, DownloadApp: __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default.a },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    novel: function novel(state) {
      return state.book.novel;
    },
    reality: function reality(state) {
      return state.book.reality;
    },
    travel: function travel(state) {
      return state.book.travel;
    },
    bookTags: function bookTags(state) {
      return state.book.bookTags;
    }
  })),
  methods: {
    getBook: function getBook() {
      this.$store.dispatch('getBook');
    }
  },
  created: function created() {
    this.getBook();
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Banner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tags__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Loading__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'detail-view',
  components: { Banner: __WEBPACK_IMPORTED_MODULE_2__components_Banner___default.a, Tags: __WEBPACK_IMPORTED_MODULE_3__components_Tags___default.a, DownloadApp: __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default.a, Loading: __WEBPACK_IMPORTED_MODULE_5__components_Loading___default.a },
  data: function data() {
    return {
      showLoading: true
    };
  },

  filters: {
    toArray: function toArray(value) {
      return value.split(',');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    content: function content() {
      return this.eventItem.content.replace(/<img.+?>/ig, '');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    eventItem: function eventItem(state) {
      return state.activities.eventItem;
    }
  })),
  created: function created() {
    var _this = this;

    var id = this.$route.params.id;

    this.$store.dispatch({
      type: 'getSingleEvent',
      id: id
    }).then(function (res) {
      _this.showLoading = false;
    });
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserBar__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UserBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_UserBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Group__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group-view',
  components: { UserBar: __WEBPACK_IMPORTED_MODULE_2__components_UserBar___default.a, Group: __WEBPACK_IMPORTED_MODULE_3__components_Group___default.a, DownloadApp: __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default.a },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    group_a: function group_a(state) {
      return state.group.group_a;
    },
    group_b: function group_b(state) {
      return state.group.group_b;
    },
    group_c: function group_c(state) {
      return state.group.group_c;
    }
  })),
  created: function created() {
    this.$store.dispatch('getGroup');
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SubNav__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SubNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SubNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_List__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Loading__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-view',
  components: { SubNav: __WEBPACK_IMPORTED_MODULE_3__components_SubNav___default.a, List: __WEBPACK_IMPORTED_MODULE_4__components_List___default.a, InfiniteLoading: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_loading___default.a, Loading: __WEBPACK_IMPORTED_MODULE_5__components_Loading___default.a },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    events: function events(state) {
      return state.activities.events;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onInfinite: function onInfinite() {
      var _this = this;

      setTimeout(function () {
        _this.loadMore();
        _this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      }, 1000);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapActions */])(['loadMore']))
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login-view',
  data: function data() {
    return {
      loginState: '登录',
      isDisabled: false,
      isShow: 0,
      passType: 'password',
      error: '' };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    email: function email(state) {
      return state.user.temp_email;
    },
    token: function token(state) {
      return state.user.temp_token;
    }
  })),
  methods: {
    showPwd: function showPwd() {
      this.isShow = this.isShow ? 0 : 1;
      this.isShow ? this.passType = 'text' : this.passType = 'password';
    },
    updateData: function updateData(e) {
      this.$store.commit({
        type: 'updateData',
        name: e.target.name,
        value: e.target.value
      });
    },
    beforeSubmit: function beforeSubmit() {
      this.isDisabled = true;
      this.loginState = '正在登录...';
    },
    onSuccess: function onSuccess(res) {
      this.$router.push({ name: 'StatusView' });
    },
    onError: function onError(err) {
      this.error = err.body.error;
      this.loginState = '登录';
      this.isDisabled = false;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.beforeSubmit();

      this.$store.dispatch({
        type: 'login',
        email: this.email,
        token: this.token
      }).then(function (res) {
        _this.onSuccess(res);
      }, function (err) {
        _this.onError(err);
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$store.getters.currentUser.email) {
        vm.$router.push({ name: 'StatusView' });
      } else {
        next();
      }
    });
  },
  created: function created() {
    if (localStorage.getItem('email')) {
      this.$store.commit({
        type: 'getLocalUser'
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Scroller__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Types__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DownloadApp__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'movie-view',
  components: { Scroller: __WEBPACK_IMPORTED_MODULE_2__components_Scroller___default.a, Types: __WEBPACK_IMPORTED_MODULE_3__components_Types___default.a, DownloadApp: __WEBPACK_IMPORTED_MODULE_4__components_DownloadApp___default.a },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    hotMovies: function hotMovies(state) {
      return state.movie.hotMovies;
    },
    topMovies: function topMovies(state) {
      return state.movie.topMovies;
    },
    newMovies: function newMovies(state) {
      return state.movie.newMovies;
    },
    movieTags: function movieTags(state) {
      return state.movie.movieTags;
    }
  })),
  methods: {
    getMovie: function getMovie() {
      this.$store.dispatch('getMovie');
    }
  },
  created: function created() {
    this.getMovie();
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_TalionView__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_TalionView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_TalionView__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pages-view',
  components: { HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default.a, TalionView: __WEBPACK_IMPORTED_MODULE_1__views_TalionView___default.a },
  data: function data() {
    return {
      talion: ''
    };
  },

  methods: {
    open: function open() {
      this.talion = 'open';
    },
    close: function close() {
      this.talion = '';
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register-view',
  data: function data() {
    return {
      isComplete: false,
      isDisabled: false,
      isShow: 0,
      registerState: '立即注册',
      passType: 'password',
      error: '',
      email: '',
      pass: '',
      name: '',
      token: ''
    };
  },

  methods: {
    showPwd: function showPwd() {
      this.isShow = this.isShow ? 0 : 1;
      this.isShow ? this.passType = 'text' : this.passType = 'password';
    },
    beforeSubmit: function beforeSubmit() {
      this.isDisabled = true;
      this.registerState = '正在提交...';
    },
    onSuccess: function onSuccess(res) {
      this.isComplete = true;
      this.token = res.body.token;
    },
    onError: function onError(err) {
      this.error = err.body.error;
      this.registerState = '立即注册';
      this.isDisabled = false;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.beforeSubmit();

      this.$store.dispatch({
        type: 'register',
        email: this.email,
        pass: this.pass,
        name: this.name
      }).then(function (res) {
        _this.onSuccess(res);
      }, function (err) {
        _this.onError(err);
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.$store.getters.currentUser.email) {
        vm.$router.push({ name: 'StatusView' });
      } else {
        next();
      }
    });
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Group__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Group__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-view',
  components: { Group: __WEBPACK_IMPORTED_MODULE_2__components_Group___default.a },
  data: function data() {
    return {
      queryStr: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    queryRes_movie: function queryRes_movie(state) {
      return state.search.queryRes_movie;
    }
  })),
  methods: {
    query: function query() {
      if (this.queryStr) {
        this.$store.dispatch({
          type: 'query',
          queryStr: this.queryStr
        });
      }
    }
  },
  created: function created() {
    var q = this.$route.params.q;
    if (q) {
      this.queryStr = q;
      this.query();
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Banner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UserBar__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UserBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_UserBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Card__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DownloadApp__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DownloadApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DownloadApp__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'status',
  components: { Banner: __WEBPACK_IMPORTED_MODULE_0__components_Banner___default.a, UserBar: __WEBPACK_IMPORTED_MODULE_1__components_UserBar___default.a, Card: __WEBPACK_IMPORTED_MODULE_2__components_Card___default.a, DownloadApp: __WEBPACK_IMPORTED_MODULE_3__components_DownloadApp___default.a },
  data: function data() {
    return {
      items: new Array(10)
    };
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Banner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Rating__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Marking__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Marking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Marking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Card__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_List__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Scroller__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tags__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DownloadApp__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DownloadApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_DownloadApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loading__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Loading__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subject-view',
  components: {
    Banner: __WEBPACK_IMPORTED_MODULE_2__components_Banner___default.a,
    Rating: __WEBPACK_IMPORTED_MODULE_3__components_Rating___default.a,
    Marking: __WEBPACK_IMPORTED_MODULE_4__components_Marking___default.a,
    Card: __WEBPACK_IMPORTED_MODULE_5__components_Card___default.a,
    List: __WEBPACK_IMPORTED_MODULE_6__components_List___default.a,
    Scroller: __WEBPACK_IMPORTED_MODULE_7__components_Scroller___default.a,
    Tags: __WEBPACK_IMPORTED_MODULE_8__components_Tags___default.a,
    DownloadApp: __WEBPACK_IMPORTED_MODULE_9__components_DownloadApp___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_10__components_Loading___default.a
  },
  data: function data() {
    return {
      showLoading: true,
      isExpand: true,
      items: new Array(5)
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    subject: function subject(state) {
      return state.subject.subject;
    },
    adImgUrl: function adImgUrl(state) {
      return state.subject.adImgUrl;
    },
    questions: function questions(state) {
      return state.subject.questions;
    },
    movieTags: function movieTags(state) {
      return state.movie.movieTags;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    subjectMeta: 'subjectMeta',
    summary: 'summary',
    genres: 'genres'
  })),
  methods: {
    expand: function expand(event) {
      this.isExpand = false;
    }
  },
  created: function created() {
    var _this = this;

    var id = this.$route.params.id;
    var classify = this.$route.params.classify;

    this.$store.dispatch({
      type: 'getSingleSubject',
      id: id,
      classify: classify
    }).then(function (res) {
      _this.showLoading = false;
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SubNav__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SubNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SubNav__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'talion-view',
  components: { SubNav: __WEBPACK_IMPORTED_MODULE_0__components_SubNav___default.a },
  data: function data() {
    return {
      queryStr: ''
    };
  },

  methods: {
    closeTalion: function closeTalion() {
      this.$emit('closeTalion');
    },

    goSearch: function goSearch() {
      this.$emit('closeTalion');
      this.$router.push({
        name: 'SearchView',
        params: {
          q: this.queryStr
        }
      });
    }
  }
});

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar.9297a89.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/book_zw.fc645eb.jpg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading_green.c0f9be0.gif";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/promotion_bg.b7abee9.jpg";

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMpaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjAtYzA2MCA2MS4xMzQ3NzcsIDIwMTAvMDIvMTItMTc6MzI6MDAgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDUzUgV2luZG93cyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFQ0JBOEMxMUM0OEExMURGODgxOEIxRTlGOThEMEIyNCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0JBOEMxMkM0OEExMURGODgxOEIxRTlGOThEMEIyNCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkVDQkE4QzBGQzQ4QTExREY4ODE4QjFFOUY5OEQwQjI0IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDQkE4QzEwQzQ4QTExREY4ODE4QjFFOUY5OEQwQjI0Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoKDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgAMAAwAwERAAIRAQMRAf/EAGQAAAICAwEAAAAAAAAAAAAAAAAFAQQCAwYHAQEAAAAAAAAAAAAAAAAAAAAAEAABAwMDBAEFAAAAAAAAAAABAAIDETEEQVEFIYESE8FxkdEiQhEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A99QCAQCAQSLhBCDbi47siZsTelbnYaoOhgw8eBoDGCurj1J7oDIwsedpD2Cujh0I7oOeyYHQTOiddtjuNCg1i4QQgY8IWjKcDcsNPuEDtAIEfNFpywBcMFfrUoKAuEEIM4ZXxSNkYaOaahA8g5fFkaPM+t+oNuxQRkcvixtPrPsfoBbuUCSWV8sjpHmrnGpKDEXCCEDDE4iWVofKfWw2H9H8IGDOJwWjqwuO5J+KIB/E4Lh0YWncE/NUC/M4mWFpfGfZGLj+ggoC4QW+Mx2yZQ9g/Vg8iDY0sgf+TdwgPJu4QHk3cIDybuECDkcdsWYRGP0dRwA0qg//2Q=="

/***/ }),
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  "data-v-4a8463e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(186),
  /* scopeId */
  "data-v-0b8274da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  "data-v-180beb86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  "data-v-4e2630ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(195),
  /* scopeId */
  "data-v-45f6a39c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  "data-v-37ef6108",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(156)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  "data-v-d75ddaf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(185),
  /* scopeId */
  "data-v-05d2ab4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(191),
  /* scopeId */
  "data-v-1252f03e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(157)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  "data-v-e60fb580",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  "data-v-5f499176",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(153)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  "data-v-7fecb78f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  "data-v-5d66956e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(184),
  /* scopeId */
  "data-v-045ebeb4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "talion-view"
  }, [_c('div', {
    staticClass: "header-bar"
  }, [_c('span', {
    staticClass: "close-talion",
    on: {
      "click": _vm.closeTalion
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('form', {
    staticClass: "search",
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.queryStr),
      expression: "queryStr",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "search",
      "name": "query"
    },
    domProps: {
      "value": (_vm.queryStr)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.goSearch()
      },
      "change": function($event) {
        _vm.queryStr = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('sub-nav', {
    attrs: {
      "mold": "navBottom"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "has-header"
  }, [_c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(35, 132, 232)"
    }
  }, [_vm._v("电影")]), _vm._v(" "), _c('span', [_vm._v("影院热映")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(230, 70, 126)"
    }
  }, [_vm._v("同城")]), _vm._v(" "), _c('span', [_vm._v("周末活动")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(159, 120, 96)"
    }
  }, [_vm._v("阅读")]), _vm._v(" "), _c('span', [_vm._v("电子书")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(225, 100, 77)"
    }
  }, [_vm._v("东西")]), _vm._v(" "), _c('span', [_vm._v("心爱之物")])])])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(122, 106, 219)"
    }
  }, [_vm._v("电视")]), _vm._v(" "), _c('span', [_vm._v("正在热播")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(42, 184, 204)"
    }
  }, [_vm._v("小组")]), _vm._v(" "), _c('span', [_vm._v("志趣相投")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(87, 116, 197)"
    }
  }, [_vm._v("游戏")]), _vm._v(" "), _c('span', [_vm._v("虚拟世界")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(64, 207, 169)"
    }
  }, [_vm._v("FM")]), _vm._v(" "), _c('span', [_vm._v("红心歌单")])])])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(159, 120, 96)"
    }
  }, [_vm._v("图书")]), _vm._v(" "), _c('span', [_vm._v("畅销排行")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(244, 143, 46)"
    }
  }, [_vm._v("音乐")]), _vm._v(" "), _c('span', [_vm._v("新碟榜")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(89, 108, 221)"
    }
  }, [_vm._v("应用")]), _vm._v(" "), _c('span', [_vm._v("玩手机")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "rgb(66, 189, 86)"
    }
  }, [_vm._v("市集")]), _vm._v(" "), _c('span', [_vm._v("购买原创")])])])])])
}]}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-view has-header"
  }, [_c('scroller', {
    attrs: {
      "title": "影院热映",
      "type": "hasCover",
      "items": _vm.hotMovies
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "免费在线观影",
      "type": "hasCover",
      "items": _vm.topMovies
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "新片速递",
      "type": "hasCover",
      "items": _vm.newMovies
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "发现好电影",
      "type": "onlyString",
      "items": _vm.movieTags
    }
  }), _vm._v(" "), _c('types'), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marking"
  }, [_vm._t("movie"), _vm._v(" "), _vm._t("book")], 2)
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "user-bar",
    attrs: {
      "to": {
        name: _vm.currentLink
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.currentUser.name) ? [_c('img', {
    attrs: {
      "src": __webpack_require__(164),
      "alt": "avatar"
    }
  })] : [_c('img', {
    attrs: {
      "src": __webpack_require__(168),
      "alt": "未登陆"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "holder"
  }, [_vm._v(_vm._s(_vm.holder))]), _vm._v(" "), _c('div', {
    staticClass: "icon icon-camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon icon-pen"
  })])
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('strong', [_vm._v("\n          豆瓣"), (_vm.mold === 'quote') ? _c('span', [_vm._v("写了日记")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "timestamp"
  }, [_vm._v("2017-03-01 19:30:41")])])])]), _vm._v(" "), (_vm.mold === 'quote') ? _c('div', {
    staticClass: "article-card"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      豆瓣App 4.12.0 主要更新\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n      - 可以写读书笔记了，同时支持编辑。随时随地，摘录怦然心动的段落，写下阅读时的随感。来写笔记吧，你...\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.mold === 'comment') ? _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n    可以写读书笔记了，同时支持编辑。随时随地，摘录怦然心动的段落，写下阅读时的随感。来写笔记吧，你\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(1), _vm._v(" "), (_vm.mold === 'quote') ? _c('span', {
    staticClass: "btn comment"
  }, [_c('i', [_vm._v("0")])]) : _vm._e(), _vm._v(" "), (_vm.mold === 'quote') ? _c('span', {
    staticClass: "btn retweet"
  }, [_c('i', [_vm._v("1")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn more"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(47),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn like"
  }, [_c('i', [_vm._v("4")])])
}]}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(166),
      "alt": "loading"
    }
  })])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-nav"
  }, [(_vm.mold === 'navBottom') ? _c('div', {
    staticClass: "navBottom"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegisterView'
      }
    }
  }, [_vm._v("注册帐号")]), (_vm.currentUser.email) ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      },
      "replace": ""
    }
  }, [_vm._v("登录豆瓣")])]], 2), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.mold === 'quickNav') ? _c('div', {
    staticClass: "quickNav"
  }, [_c('ul', {
    staticClass: "quick-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MovieView'
      }
    }
  }, [_vm._v("影院热映")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'StatusView'
      }
    }
  }, [_vm._v("欧美新碟榜")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegisterView'
      }
    }
  }, [_vm._v("注册帐号")])], 1), _vm._v(" "), _c('li', [(_vm.currentUser.email) ? [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      },
      "replace": ""
    }
  }, [_vm._v("登录豆瓣")])]], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://movie.douban.com/"
    }
  }, [_vm._v("使用桌面版")]), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("使用豆瓣App")])])
}]}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-view"
  }, [_c('header-bar', {
    on: {
      "showTalion": _vm.open
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('talion-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.talion),
      expression: "talion"
    }],
    on: {
      "closeTalion": _vm.close
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-view has-header"
  }, [_c('scroller', {
    attrs: {
      "title": "最受关注图书｜虚构类",
      "type": "hasCover",
      "items": _vm.novel
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "最受关注图书｜非虚构类",
      "type": "hasCover",
      "items": _vm.reality
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "豆瓣纸书",
      "type": "hasCover",
      "items": _vm.travel
    }
  }, [_c('div', {
    staticClass: "promItem",
    slot: "promItem"
  }, [_c('img', {
    staticClass: "corver",
    attrs: {
      "src": __webpack_require__(165),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("¥ 68")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("造物")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("改变世界的万物图典，3000幅图里的发明与冒险")])])])]), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "发现好书",
      "type": "onlyString",
      "items": _vm.bookTags
    }
  }), _vm._v(" "), _c('types'), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-view has-header"
  }, [_c('sub-nav', {
    attrs: {
      "mold": "quickNav"
    }
  }), _vm._v(" "), _c('list', {
    attrs: {
      "mold": "thumbnail",
      "items": _vm.events
    }
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite
    }
  }, [_c('loading', {
    slot: "spinner"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags"
  }, [_c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(item.name ? item.name : item))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-view has-header"
  }, [_c('user-bar'), _vm._v(" "), _c('group', {
    attrs: {
      "title": "租房找室友",
      "items": _vm.group_a
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("更多相关小组")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "来聊五块钱",
      "items": _vm.group_b
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("来聊五块钱")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "买买买",
      "items": _vm.group_c
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("更多相关小组")])]), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HomeView'
      }
    }
  }, [_vm._v("\n      豆瓣\n    ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "color": "#2384E8"
    },
    attrs: {
      "to": {
        name: 'MovieView'
      }
    }
  }, [_vm._v("\n        电影\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "#9F7860"
    },
    attrs: {
      "to": {
        name: 'BookView'
      }
    }
  }, [_vm._v("\n        图书\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "#E4A813"
    },
    attrs: {
      "to": {
        name: 'StatusView'
      }
    }
  }, [_vm._v("\n        广播\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "#2AB8CC"
    },
    attrs: {
      "to": {
        name: 'GroupView'
      }
    }
  }, [_vm._v("\n        小组\n      ")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "talion",
    on: {
      "click": _vm.showTalion
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-view has-header"
  }, [_c('banner', {
    attrs: {
      "title": "每天看点好内容"
    }
  }), _vm._v(" "), (!_vm.showLoading) ? [_c('div', {
    staticClass: "info"
  }, [_c('h2', [_vm._v("\n        " + _vm._s(_vm.eventItem.title) + "\n        "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.eventItem.loc_name))])]), _vm._v(" "), _c('div', {
    staticClass: "poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.eventItem.image_hlarge,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("时间:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.begin_time))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.eventItem.end_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("地点:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("费用:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.fee_str))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("类型:  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.eventItem.category_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', [_vm._v("起始时间:  ")]), _vm._v(" "), _c('ul', [(_vm.eventItem.owner) ? _c('li', [_vm._v(_vm._s(_vm.eventItem.owner.name))]) : _vm._e()])]), _vm._v(" "), (_vm.eventItem.tags) ? _c('tags', {
    attrs: {
      "items": _vm._f("toArray")(_vm.eventItem.tags)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('h2', [_vm._v("活动详情")]), _vm._v(" "), (_vm.eventItem.content) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('download-app')] : _vm._e(), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("分类浏览")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "type-list"
  }, [_vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.baseUri + item.href
      }
    }, [_vm._v("\n          " + _vm._s(item.title)), _c('span')])])
  }), _vm._v(" "), _c('li')], 2)])])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('ul', {
    staticClass: "content"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'SubjectView',
          params: {
            classify: item.subtype ? item.subtype : 'book',
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "group-meta"
    }, [(item.images.small) ? _c('img', {
      attrs: {
        "src": item.images.small,
        "alt": "cover"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "group-info"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.rating) ? _c('rating', {
      attrs: {
        "rating": item.rating
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.group_member) ? _c('span', {
      staticClass: "group-member"
    }, [_vm._v("20005人")]) : _vm._e()]), _vm._v(" "), (item.group_topic) ? _c('div', {
      staticClass: "group-topic"
    }, [_c('span', [_vm._v(_vm._s(item.group_topic.time))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.group_topic.title))])]) : _vm._e()])], 1)
  })), _vm._v(" "), _vm._t("more")], 2)
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-view has-header"
  }, [_c('banner', {
    attrs: {
      "title": "聊聊你的观影感受"
    }
  }), _vm._v(" "), (!_vm.showLoading) ? [_c('div', {
    staticClass: "subject-card"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.subject.title))]), _vm._v(" "), _c('div', {
    staticClass: "subject-info"
  }, [_c('div', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [(_vm.subject.images) ? _c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "cover"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.subject.rating) ? _c('div', {
    staticClass: "left"
  }, [_c('rating', {
    attrs: {
      "rating": _vm.subject.rating
    }
  }, [_c('span', {
    slot: "ratingsCount"
  }, [_vm._v(_vm._s(_vm.subject.ratings_count) + "人评价")])]), _vm._v(" "), (_vm.subject.genres && _vm.subjectMeta) ? [_c('p', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.subjectMeta))]), _vm._v(" "), _c('a', {
    staticClass: "open-app",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("用App查看影人资料")])] : _vm._e(), _vm._v(" "), (_vm.subject.author && _vm.subjectMeta) ? [_c('p', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.subjectMeta))]), _vm._v(" "), _c('a', {
    staticClass: "buy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("在豆瓣购买")])] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.subject.author) ? _c('div', {
    staticClass: "vendors-link"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('marking', [(_vm.subject.author) ? _c('template', {
    slot: "book"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("想读")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("在读")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("读过")])], 1) : _c('template', {
    slot: "movie"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("想看")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("看过")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "subject-intro"
  }, [_c('h2', [_vm._v(_vm._s(_vm.subject.title) + "的简介")]), _vm._v(" "), _c('p', [(_vm.summary && _vm.subject.summary) ? [_vm._v("\n            " + _vm._s(_vm.isExpand ? _vm.summary : _vm.subject.summary) + "……\n          ")] : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpand),
      expression: "isExpand"
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.expand
    }
  }, [_vm._v("\n            (展开)\n          ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "genres"
  }, [_c('h2', [_vm._v("查看更多相关分类")]), _vm._v(" "), (_vm.genres) ? [_c('tags', {
    attrs: {
      "items": _vm.genres
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "subject-pics"
  }, [_c('h2', [_vm._v(_vm._s(_vm.subject.title) + "的图片")]), _vm._v(" "), (_vm.subject.images) ? _c('ul', [_c('li', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "poster"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "poster"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "poster"
    }
  })])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-comments"
  }, [_c('h2', [_vm._v(_vm._s(_vm.subject.title) + "的短评")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, [_vm._l((_vm.items), function(item) {
    return _c('card', {
      key: item,
      attrs: {
        "mold": "comment"
      }
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("显示更多评论")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ad"
  }, [_c('banner', {
    attrs: {
      "adImg": _vm.adImgUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-question"
  }, [_c('h2', [_vm._v("关于" + _vm._s(_vm.subject.title) + "的问答")]), _vm._v(" "), _c('list', {
    attrs: {
      "items": _vm.questions
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("显示更多问答")])], 1), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "推荐的豆列",
      "type": "onlyString",
      "items": _vm.movieTags
    }
  }), _vm._v(" "), _c('download-app')] : _vm._e(), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link"
  }, [_vm._v("\n          在哪儿买这本书？\n          "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            豆瓣阅读电子书 66.00元起\n          ")])])
}]}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.items), function(item) {
    return (_vm.mold === 'thumbnail') ? [_c('router-link', {
      staticClass: "thumbnail",
      attrs: {
        "to": {
          name: 'DetailView',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('img', {
      attrs: {
        "src": item.image_hlarge,
        "alt": "cover"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("subStr")(item.content)))])]), _vm._v(" "), _c('div', {
      staticClass: "author"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.category_name))]), _vm._v(" "), (item.subcategory_name) ? _c('span', {
      staticClass: "label"
    }, [_vm._v("\n          本活动来自栏目 " + _vm._s(item.subcategory_name) + "\n        ")]) : _vm._e()])])] : _vm._e()
  }), _vm._v(" "), (_vm.mold === 'basic') ? [_c('ul', {
    staticClass: "basic"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.comments))])])])
  }))] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-view has-header"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('form', {
    attrs: {
      "id": "search_form",
      "onsubmit": "return false"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.queryStr),
      expression: "queryStr",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "query",
      "placeholder": "搜索 书 / 影 / 音 / 标签"
    },
    domProps: {
      "value": (_vm.queryStr)
    },
    on: {
      "change": function($event) {
        _vm.queryStr = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.query()
      }
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), (_vm.queryStr) ? _c('div', {
    staticClass: "search-res"
  }, [_c('group', {
    attrs: {
      "title": "影视",
      "items": _vm.queryRes_movie
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("查看更多影视结果")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "图书",
      "items": _vm.queryRes_movie
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("查看更多图书结果")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "音乐",
      "items": _vm.queryRes_movie
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("查看更多音乐结果")])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rating) ? _c('div', {
    staticClass: "rating"
  }, [(_vm.full === 0) ? [_c('span', [_vm._v("暂无评分")])] : [_vm._l((_vm.full), function(n) {
    return [_c('span', {
      staticClass: "star-full"
    })]
  }), _vm._v(" "), _vm._l((_vm.half), function(n) {
    return [_c('span', {
      staticClass: "star-half"
    })]
  }), _vm._v(" "), _vm._l((_vm.gray), function(n) {
    return [_c('span', {
      staticClass: "star-gray"
    })]
  }), _vm._v(" "), _c('span', {
    staticClass: "average"
  }, [_vm._v(_vm._s(_vm.rating.average))])], _vm._v(" "), _vm._t("ratingsCount")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroller"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("promItem"), _vm._v(" "), (_vm.type === 'hasCover') ? _c('ul', {
    staticClass: "hasCover"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": 'subject/' + item.id,
        "append": ""
      }
    }, [(item.images) ? _c('img', {
      attrs: {
        "src": item.images.large,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.rating) ? _c('rating', {
      attrs: {
        "rating": item.rating
      }
    }) : _vm._e()], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.type === 'onlyString') ? _c('ul', {
    staticClass: "onlyString"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticStyle: {
        "border-color": "#FFAC2D"
      }
    }, [(!item.line) ? _c('a', {
      style: ({
        color: item.color
      }),
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])
  })) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status has-header"
  }, [_c('banner'), _vm._v(" "), _c('user-bar'), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, [_vm._l((_vm.items), function(item) {
    return _c('card', {
      key: item,
      attrs: {
        "mold": "quote"
      }
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("显示更多广播")])], 2), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [(_vm.adImg) ? [(_vm.adImg) ? _c('div', {
    staticClass: "banner-bg ad"
  }, [_c('img', {
    attrs: {
      "src": _vm.adImg,
      "alt": "ad"
    }
  }), _vm._v(" "), _c('span', [_vm._v("广告")])]) : _vm._e()] : [_c('div', {
    staticClass: "banner-bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(167),
      "alt": "cover"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('span', {
    staticClass: "download"
  }, [_vm._v("极速下载")]), _vm._v(" "), _c('span', {
    staticClass: "open"
  }, [_vm._v("打开")])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-app"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(47),
      "alt": "下载豆瓣"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('strong', [_vm._v("豆瓣")]), _vm._v(" "), _c('div', [_vm._v("我们的精神角落")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去 App Store 免费下载 iOS 客户端")])])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-view"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "method": "get"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit()
      }
    }
  }, [(_vm.error) ? _c('p', {
    staticClass: "tip error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-user"
  }, [_c('label', [_c('strong', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.updateData]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-pwd"
  }, [_c('label', [_c('strong', [_vm._v("请输入密码")]), _vm._v(" "), (_vm.passType === 'password') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "password",
      "name": "token",
      "placeholder": "Token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }, _vm.updateData]
    }
  })] : _vm._e(), _vm._v(" "), (_vm.passType === 'text') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "text",
      "name": "token",
      "placeholder": "Token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }, _vm.updateData]
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    class: {
      show: _vm.isShow
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "submit",
    class: {
      disabled: _vm.isDisabled
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loginState) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "more-login"
  }, [_vm._v("使用其他方式登录 & 找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RegisterView'
      }
    }
  }, [_vm._v("注册豆瓣帐号")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("下载豆瓣App")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    attrs: {
      "href": "javascript:history.go(-1);"
    }
  }, [_vm._v("取消")]), _vm._v("登录豆瓣\n  ")])
}]}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-view"
  }, [(_vm.isComplete) ? [_c('h1', {
    staticClass: "title"
  }, [_vm._v("注册成功")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "onsubmit": "return false"
    }
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("请复制以下Token进行登录")]), _vm._v(" "), _c('div', {
    staticClass: "form-alias"
  }, [_c('label', [_c('strong', [_vm._v("token")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "text",
      "name": "token",
      "placeholder": "token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit"
  }, [_c('router-link', {
    staticClass: "submit",
    attrs: {
      "to": {
        name: 'LoginView'
      },
      "tag": "button"
    }
  }, [_vm._v("\n          去登录\n        ")])], 1)])] : [_c('h1', {
    staticClass: "title"
  }, [_vm._v("欢迎加入豆瓣")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit()
      }
    }
  }, [(_vm.error) ? _c('p', {
    staticClass: "tip error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-alias"
  }, [_c('label', [_c('strong', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-pwd"
  }, [_c('label', [_c('strong', [_vm._v("请输入密码")]), _vm._v(" "), (_vm.passType === 'password') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.pass),
      expression: "pass",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "name": "pass",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.passType === 'text') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.pass),
      expression: "pass",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "pass",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    class: {
      show: _vm.isShow
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-name"
  }, [_c('label', [_c('strong', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit"
  }, [_c('button', {
    staticClass: "submit",
    class: {
      disabled: _vm.isDisabled
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("\n          " + _vm._s(_vm.registerState) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "agreement"
  }, [_vm._v("点击「注册」代表你已阅读并同意用户使用协议")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("下载豆瓣App")])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "view"
  }), _vm._v(" "), _c('router-view', {
    staticClass: "view",
    attrs: {
      "name": "subject"
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "view",
    attrs: {
      "name": "search"
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[60]);


// WEBPACK FOOTER //
// static/js/app.4e3f2a54e9b7bed6f89f.js